// extracted by mini-css-extract-plugin
module.exports = {"mapboxgl-marker":"index__mapboxgl-marker___2CBKx"};